import {EmployeeEN} from "./employee/en";
import {EmployeeContractEN} from "./contract/en";
import {EmployeeFineEN} from "./fine/en";
import {EmployeeRewardWelfareEN} from "./reward-welfare/en";

export const RecordEN = {
    ...EmployeeEN,
    ...EmployeeContractEN,
    ...EmployeeFineEN,
    ...EmployeeRewardWelfareEN
}